import type { CompanySiteType as ApiCompanySiteType } from 'src/api/generated/touring/types';
import { mapAddress, mapContact } from '../common';
import { CompanySiteType } from './types';

export const mapCompanySiteType = (
  site: ApiCompanySiteType
): CompanySiteType => ({
  id: site.id,
  address: mapAddress(site.address),
  contact: mapContact(site.contact),
  employeeCount: site.employees,
  isHeadquarter: site.isHeadquarter,
});
